import React, { useState } from 'react'
import { Grommet, Layer } from 'grommet'
import { WebUtils } from 'galarm-shared'
import { Constants, GlobalConfig } from 'galarm-config'
import PremiumRoute from './PremiumRoute'
import ProgressDialog from './ProgressDialog'

const PremiumApp = () => {
  // Always light theme for the premium purchase flow
  const theme = WebUtils.getGrommetTheme(Constants.COLOR_SCHEMES.LIGHT)

  const defaultProgressConfiguration = {
    state: '',
    message: '',
    closeable: false
  }
  const [progressConfiguration, setProgressConfiguration] = useState(
    defaultProgressConfiguration
  )
  const showProgress = progressConfiguration.message

  GlobalConfig.showProgress = setProgressConfiguration
  GlobalConfig.dismissProgress = () =>
    setProgressConfiguration(defaultProgressConfiguration)

  return (
    <Grommet full theme={theme}>
      <PremiumRoute />
      {showProgress && (
        <Layer
          background="lightTint"
          onEsc={
            progressConfiguration.closeable
              ? GlobalConfig.dismissProgress
              : undefined
          }
          onClickOutside={
            progressConfiguration.closeable
              ? GlobalConfig.dismissProgress
              : undefined
          }>
          <ProgressDialog progressConfiguration={progressConfiguration} />
        </Layer>
      )}
    </Grommet>
  )
}

export default PremiumApp
